import {PHONE_INTERNATIONAL_VALUE} from 'front-onceforall-core/dist/components/TextPhoneNumber';
import {COUNTRY_CODE} from 'front-onceforall-core/dist/utils/country';

export function getPhoneLocaleFromCountry(country) {
  if (COUNTRY_CODE[country]) {
    return COUNTRY_CODE[country];
  }

  return PHONE_INTERNATIONAL_VALUE;
}
